import { Suspense } from 'react';
import { matchPath } from 'react-router';

import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { RouteScreenContext } from 'components/app/AppContext';
import { ScreenTemplate } from './ScreenTemplate';

import type { Route } from 'components/app/routes/app-routes-revamp';

type RouteScreenProps = {
  route: Route;
  routes: Route[];
};

export const RouteScreen = (props: RouteScreenProps) => {
  const { route, routes } = props;
  const { Template: RouteTemplate, noIndex } = route;
  const routeScreenContextValue = { route, routes };
  const Template = RouteTemplate || ScreenTemplate;

  const isLoading = !matchPath(
    `${import.meta.env.VITE_PATH_PREFIX || ''}${route.path}`,
    window.location.pathname
  );

  return (
    <>
      {noIndex && <meta name="robots" content="noindex" />}

      <RouteScreenContext.Provider value={routeScreenContextValue}>
        <main id="#content">
          <div hidden={!isLoading}>
            <NsStopgap />
          </div>
          <div hidden={isLoading}>
            <Suspense fallback={<NsStopgap />}>
              <Template {...route} />
            </Suspense>
          </div>
        </main>
      </RouteScreenContext.Provider>
    </>
  );
};
